import { useEffect, useRef, useState } from "react";
import "./home.css";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.i18n.js";
import { useOnInView } from "react-intersection-observer";
import { ReactComponent as AvatarIcon } from "../../svg/avatar_icon.svg";
import { ReactComponent as StarsIcon } from "../../svg/stars_icon.svg";
import Example_1 from "../../svg/example_1.jpg";
import Example_2 from "../../svg/example_2.jpg";
import Example_3 from "../../svg/example_3.jpg";
import Example_4 from "../../svg/example_4.jpg";
import Example_5 from "../../svg/example_5.jpg";
import SendForm from "../../Elements/SendForm/send-form.jsx";
import UseAnimations from "react-useanimations";
import arrowLeft from "react-useanimations/lib/arrowLeft";
import { arrowRight, checkCircle } from "react-useanimations/icons";
import { useMeasure } from "react-use";

export const HomeBottom = () => {
  const [home_examples_slider, { width }] = useMeasure();
  const home_examples_slider_areaRef = useRef();

  useEffect(() => {
    if (width != 0) {
      if (width > 806) {
        document.getElementById("home_examples_slider_area").style.transform =
          `translateX(-${400 - (width - 400 - 200) / 2 + 500}px)`;
      } else {
        document.getElementById("home_examples_slider_area").style.transform = "translateX(0px)";
        const nodes = document.getElementsByClassName("home_examples_slider_slide");
        Array.from(nodes).forEach((elem) => {
          elem.style.width = width + "px";
        });

        const sliderNodes = document.getElementsByClassName("home_feedback_slider_area_elem");
        Array.from(sliderNodes).forEach((elem) => {
          elem.style.width = width + "px";
        });
      }
    }
  }, [width]);

  // const trackingRef = useOnInView(
  //   (inView, entry) => {
  //     if (inView) {
  //     }
  //   },
  //   {
  //     threshold: 0.5,
  //     triggerOnce: true,
  //   },
  // );

  return (
    <div className="home_area">
      <SendForm
        titleFirst="Нет времени изучать информацию ?"
        titleSecond="Мы сами Вам перезвоним и проконсультируем"
        firstInputPlaceholder="Как к Вам обращаться?"
        secondInputPlaceholder="Телефон для связи"
        taskType="Заявка на перезвон"
      />

      <div className="home_block_info">
        <span className="home_block_info_title">Почему мы?</span>

        <div className="home_block_info_rows">
          <div className="home_block_info_row">
            <div>
              <UseAnimations strokeColor="#7ac142" animation={checkCircle} size={40} />
            </div>
            <span>«Гарантируем юридическую чистоту»</span>
          </div>

          <div className="home_block_info_row">
            <div>
              <UseAnimations strokeColor="#7ac142" animation={checkCircle} size={40} />
            </div>
            <span>
              Проверяем историю автомобиля не только по открытым базам (ГИБДД), но и по специализированным сервисам. Мы
              гарантируем отсутствие залогов, ограничений, арестов и криминальной истории. Ваша покупка защищена на 100%
              с юридической точки зрения.
            </span>
          </div>

          <div className="home_block_info_row">
            <div>
              <UseAnimations strokeColor="#7ac142" animation={checkCircle} size={40} />
            </div>
            <span>
              "Наша услуга окупается" Наши специалисты знают реальную рыночную стоимость машин. Мы не только находим
              технически исправные варианты, но и ведём жёсткий, но корректный торг от вашего имени. Средняя экономия
              при торге и за счёт выявленных скрытых дефектов часто в 2-3 раза превышает стоимость нашей услуги.
            </span>
          </div>
        </div>
      </div>

      <div className="home_statistics">
        <div>
          <span>6</span>
          <span>лет честной работы</span>
        </div>

        <div>
          <span>11768</span>
          <span>проверенных автомобилей</span>
        </div>

        <div>
          <span>8215</span>
          <span>довольных клиентов</span>
        </div>

        <div>
          <span>97</span>
          <span>параметров проверки</span>
        </div>
      </div>

      <div className="home_selectByKey">
        <SendForm
          titleFirst="Нет времени изучать информацию ?"
          titleSecond="Мы сами Вам перезвоним и проконсультируем"
          firstInputPlaceholder="Как к Вам обращаться?"
          secondInputPlaceholder="Телефон для связи"
          taskType="Заявка на подбор под ключ"
          classType="homeByKey"
        />

        <div className="home_selectByKey_options">
          <div>Полный цикл от поиска до покупки</div>
          <div>Поиск идеального авто под ваш бюджет</div>
          <div>Торг с продавцом - выгодная цена гарантирована!</div>
          <div>100% юридическая чистота - исключим все риски</div>
          <div>Подготовка документов и сопровождение сделки</div>
          <div>Работаем по договору - гарантия и прозрачность!</div>
        </div>
      </div>

      <div className="home_examples">
        <span className="home_examples_title">Примеры работ</span>
        <div className="home_examples_body">
          <div
            className="home_examples_button"
            onClick={() => {
              if (width > 806) {
                document.getElementById("home_examples_slider_area").style.transform =
                  `translateX(${parseInt(document.getElementById("home_examples_slider_area").style.transform.replace(/[^-?\d.]/g, "")) + 500}px)`;
              } else
                document.getElementById("home_examples_slider_area").style.transform =
                  `translateX(${parseInt(document.getElementById("home_examples_slider_area").style.transform.replace(/[^-?\d.]/g, "")) + width + 20}px)`;
            }}
          >
            <UseAnimations animation={arrowLeft} size={40} />
          </div>

          <div className="home_examples_slider" id="home_examples_slider" ref={home_examples_slider}>
            <div
              id="home_examples_slider_area"
              className="home_examples_slider_area"
              ref={home_examples_slider_areaRef}
            >
              {sliderInfo.map((elem, index) => (
                <SliderSlide key={"sliderSlide_" + index} info={elem} />
              ))}
            </div>
          </div>

          <div
            className="home_examples_button"
            onClick={() => {
              if (width > 806) {
                document.getElementById("home_examples_slider_area").style.transform =
                  `translateX(${parseInt(document.getElementById("home_examples_slider_area").style.transform.replace(/[^-?\d.]/g, "")) - 500}px)`;
              } else
                document.getElementById("home_examples_slider_area").style.transform =
                  `translateX(${parseInt(document.getElementById("home_examples_slider_area").style.transform.replace(/[^-?\d.]/g, "")) - width - 20}px)`;
            }}
          >
            <UseAnimations animation={arrowRight} size={40} />
          </div>
        </div>
      </div>

      <div className="home_feedback">
        <span className="home_feedback_title">Отзывы наших клиентов</span>
        <div className="home_feedback_slider">
          <div
            className="home_examples_button"
            onClick={() => {
              if (width > 806) {
                document.getElementById("home_feedback_slider_area").style.transform == "translateX(0px)"
                  ? null
                  : (document.getElementById("home_feedback_slider_area").style.transform =
                      `translateX(${(parseFloat(document.getElementById("home_feedback_slider_area").style.transform.replace(/[^-?\d.]/g, "")) + 295).toFixed(2)}px)`);
              } else {
                document.getElementById("home_feedback_slider_area").style.transform == "translateX(0px)"
                  ? null
                  : (document.getElementById("home_feedback_slider_area").style.transform =
                      `translateX(${(parseFloat(document.getElementById("home_feedback_slider_area").style.transform.replace(/[^-?\d.]/g, "")) + width + 20).toFixed(2)}px)`);
              }
            }}
          >
            {" "}
            <UseAnimations animation={arrowLeft} size={40} />
          </div>

          <div className="home_feedback_slider">
            <div
              className="home_feedback_slider_area"
              id="home_feedback_slider_area"
              style={{ transform: "translateX(0px)" }}
            >
              {feedbackInfo.map((elem, index) => (
                <FeedbackElement info={elem} key={"home_feedback_slider_slide_" + index} />
              ))}
            </div>
          </div>

          <div
            className="home_examples_button"
            onClick={() => {
              if (width > 806) {
                document.getElementById("home_feedback_slider_area").style.transform == "translateX(-1180px)"
                  ? null
                  : (document.getElementById("home_feedback_slider_area").style.transform =
                      `translateX(${(parseFloat(document.getElementById("home_feedback_slider_area").style.transform.replace(/[^-?\d.]/g, "")) - 295).toFixed(2)}px)`);
              } else {
                parseFloat(
                  document.getElementById("home_feedback_slider_area").style.transform.replace(/[^-?\d.]/g, ""),
                ).toFixed(0) == (-(width + 20) * (feedbackInfo.length - 1)).toFixed(0)
                  ? null
                  : (document.getElementById("home_feedback_slider_area").style.transform =
                      `translateX(${(parseFloat(document.getElementById("home_feedback_slider_area").style.transform.replace(/[^-?\d.]/g, "")) - width - 20).toFixed(2)}px)`);
              }
            }}
          >
            <UseAnimations animation={arrowRight} size={40} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeTop = () => {
  return (
    <div className="content_header">
      <div className="home_top_area">
        <span className="home_top_area_title_1">Фильтруем рынок. Находим вашу машину.</span>
        <div className="home_top_area_title_2">
          <span>Купите правильный автомобиль,</span>
          <span style={{ color: "rgb(0 137 0)" }}> а не проблему.</span>
        </div>
      </div>
    </div>
  );
};

const FeedbackElement = (props) => {
  return (
    <div className="home_feedback_slider_area_elem">
      <div className="home_feedback_slider_area_elem_title">
        <AvatarIcon />
        <div>
          <span>{props.info.name}</span>
          <span>{props.info.date}</span>
        </div>
      </div>

      <div className="home_feedback_slider_area_elem_stars">
        <StarsIcon />
        <span>Сделка состоялась</span>
      </div>
      <span className="home_feedback_slider_area_elem_type">{props.info.type}</span>
      <span className="home_feedback_slider_area_elem_text">{props.info.text}</span>
    </div>
  );
};

const feedbackInfo = [
  {
    name: "Ольга",
    date: "18 сентября",
    type: "Разовый осмотр автомобиля",
    text: "Всем искренне рекомендую! Парни огромные молодцы! Помогли в подборе и диагностике! Спасибо вам!!! Посмотрела с ними три варианта которые нашла(первые два оказались неочень-мягко говоря🙈💩-хотя по фото и по уверения продавцов были без нареканий) Третий вариант отличный-на нём и остановилась!👌 Очень довольна! 👍",
  },
  {
    name: "Сергей",
    date: "17 сентября",
    type: "Разовый осмотр автомобиля",
    text: "Обратился по подбору автомобиля, все было осмотрено во время и быстро , мастер своего дела.",
  },
  {
    name: "Дмитрий",
    date: "4 сентября",
    type: "Разовый осмотр автомобиля",
    text: "Всё прошло отлично 👌 👍 Обращался из другого региона 👍",
  },
  {
    name: "Дмитрий",
    date: "1 сентября",
    type: "Подбор под ключ автомобиля",
    text: "Внимательные и отзывчивые ребята. Это тот случай, когда говорят: одно из самых важных в жизни - это найти своего портного. И если ты его нашел, то держись за него и никому не говори.  Ну, а если серьезно, то однозначно совету обращаться именно к Олегу и Даниилу. Еще буду обращаться и в дальнейшем (Сын, машину захотел) Парни, спасибо вам",
  },
  {
    name: "Никита",
    date: "25 августа",
    type: "Разовый осмотр автомобиля",
    text: "Необходимо было провести выездной осмотр автомобиля, услуга была оказана в этот же день , все сделали быстро и качественно",
  },
  {
    name: "Руслан",
    date: "24 августа",
    type: "Разовый осмотр автомобиля",
    text: "Все супер профисионал своего дела попросил посмотреть Ламборгини многие не взялись даже",
  },
  {
    name: "Аркадий",
    date: "22 августа",
    type: "Подбор под ключ автомобиля",
    text: "От всей души советую! Спасибо за отличный автоподбор! Прислали много фотографий, видео с подробным осмотром автомобиля! Дали рекомендации по ремонту и целесообразности покупки. Обращайтесь не пожалеете!",
  },
  {
    name: "Анна",
    date: "19 августа",
    type: "Разовый осмотр автомобиля",
    text: 'Обратилась за услугой "Подбор авто под ключ". Никто не рекомендовал, нашла объявление на авито, почитала информацию о ребятах, ознакомилась с отзывами и решилась. Перед тем как обратиться за помощью к ребятам, скупила не один десяток отчётов Автотеки Авито. Сведения отчетов окончательно расстроили и я приняла окончательное решение воспользоваться профессиональной помощью, поскольку самостоятельно я не справлюсь. Результат: состоялась сделка, я владелец КИО РИО 2016 года с нормальным пробегом, без ДТП, в отличном состоянии. Даниил предоставил отчёты (фото, видео, пояснил всё, ответил на все вопросы, присутствовал на сделке, довёз нас с дочкой до места совершения сделки, составил договор к.-п.). Вчера я поставила на учёт машину. Кто сомневается, не сомневайтесь, можно смело обращаться, рекомендую! Благодарю Даниила! В подтверждение, что я реальный клиент, отставляю фото авто (фото в темноте время суток, после возвращения из ГАИ).',
  },
];

const SliderSlide = (props) => {
  return (
    <div className="home_examples_slider_slide">
      <div className="home_examples_slider_slide_photo">
        <img src={props.info.photo} />
      </div>
      <span className="home_examples_slider_slide_title">{props.info.title}</span>
      <span className="home_examples_slider_slide_desc">{props.info.desc}</span>
      <div className="home_examples_slider_slide_params">
        <>
          {props.info.paramList.map((value, index) => (
            <div key={"home_examples_slider_slide_" + index}>
              <div>
                <UseAnimations strokeColor="#7ac142" animation={checkCircle} size={32} />
              </div>
              <span>{value}</span>
            </div>
          ))}
        </>
      </div>
      <span className="home_examples_slider_slide_cost">{props.info.price}</span>
    </div>
  );
};

const sliderInfo = [
  {
    title: "Lamborghini Huracan",
    desc: "27705 km | 1 владелец | 5.2 л бензин | полный",
    paramList: ["Родной пробег", "Родной окрас", "Родной пробег"],
    price: "19 990 000 ₽",
    photo: `${Example_1}`,
  },
  {
    title: "BMW X5",
    desc: "11222 km | 0 владельцев | 3.0 л бензин | полный",
    paramList: ["Родной пробег", "Родной окрас", "Без дефектов по кузову"],
    price: "11 700 000 ₽",
    photo: `${Example_2}`,
  },
  {
    title: "BMW 320d",
    desc: "163600 km | 3 владелеца | 2.0 л дизель | полный",
    paramList: ["Родной пробег", "3 крашенных элемента", "Компелктация Sport Line"],
    price: "2 130 000 ₽",
    photo: `${Example_3}`,
  },
  {
    title: "Kia Sportage",
    desc: "196200 km | 3 владелеца | 2.0 л дизель | полный",
    paramList: ["Родной пробег", "Родной окрас", "Чистая история, без ДТП"],
    price: "1 400 000 ₽",
    photo: `${Example_4}`,
  },
  {
    title: "Kia Picanto",
    desc: "74100 km | 3 владелеца | 1.2 л бензин | передний",
    paramList: ["Родной пробег", "3 крашенных элемента", "Чистая история, без ДТП"],
    price: "850 000 ₽",
    photo: `${Example_5}`,
  },
];
